const ImageLoadEvent = {
  triggerImageToLoad: (imageKeyToLoad: string) => window.dispatchEvent(new CustomEvent("imageLoad", { detail: imageKeyToLoad })),
  triggerImageLoaded: (imageKeyLoaded: string) => window.dispatchEvent(new CustomEvent("imageLoaded", { detail: imageKeyLoaded }))
}

Object.freeze(ImageLoadEvent);
export default ImageLoadEvent;